import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import { useDispatch, useSelector } from "react-redux";
import user from "../../assets/images/user.svg";
import hotelInfoTypes from "../../redux/actionType/hotelInfoTypes";
import useWindowSize from "../../utils/useWindowSize";
import { useTranslation } from "react-i18next";
import { initSojernPixel, trackSojernSearch } from "../../utils/sojernPixel";
import { hasSojernPixels } from "../../utils/sojernPixelConfig";

const HourlyDate = ({ setShowTimeSlots, location, setEnablePopup }) => {
  const dispatch = useDispatch();

  const { width } = useWindowSize();

  const { totalPeople, hourlyDate, hourlyTime, isHourlyRoom, selectedRooms, hotelData } =
    useSelector((state) => state.hotelInfo);

  const onHourlyDateChange = (dt) => {
    // setDateHr(dt);
    dispatch({ type: hotelInfoTypes.SET_HOURLY_DATE, payload: dt });
  };

  const [newDate, setNewDate] = useState(dayjs());

  const handleOnSelect = () => {
    setShowTimeSlots(true);
  };

  const onChangeDate = (date) => {
    setNewDate(date);
    onHourlyDateChange(date);
    handleOnSelect();
    
    // Track Sojern search event for hourly bookings, only for configured hotels
    if (date && hasSojernPixels(hotelData?.id)) {
      trackSojernSearch({
        checkInDate: date,
        checkOutDate: date, // For hourly bookings, check-in and check-out are the same date
        hotelId: hotelData?.id,
        hotelName: hotelData?.name,
        city: hotelData?.city,
        state: hotelData?.state,
        country: "IN",
        numberOfRooms: "",
        numberOfTravelers: totalPeople || "",
        nearestAirport: hotelData?.nearestAirport
      });
    }
  };

  const { t } = useTranslation();
  
  useEffect(() => {
    if (hotelData?.id && hasSojernPixels(hotelData?.id)) {
      initSojernPixel();
    }
  }, [hotelData?.id]);

  return (
    <div
      className="dates"
      style={{ flexDirection: "column", justifyContent: "flex-start" }}
    >
      {width > 900 && <p>{t("checkin_date_time")}</p>}
      <div className="dateHoulyContainer">
        <div className="dateContainer">
          <DatePicker
            format="dd MMM yy"
            minDate={new Date()}
            clearIcon={null}
            value={hourlyDate}
            onChange={onChangeDate}
          />
        </div>
        <div className="peopleContainer" onClick={handleOnSelect}>
          <img
            src={
              "https://ik.imagekit.io/hotelzifyprod/c6e30fed-6846-4d65-b68b-0b061da6c85d.svg"
            }
            width={"20px"}
            alt="calendar"
            height={"100%"}
          />
          {hourlyTime}
        </div>
      </div>

      {width > 900 && <p>{t("guests")}</p>}

      <div
        className="peopleContainer"
        style={{ width: "100%" }}
        onClick={() => setEnablePopup(true)}
      >
        <img src={user} alt="user" width={"25px"} height={"100%"} />{" "}
        {totalPeople} {t("guests")}
      </div>
    </div>
  );
};

export default HourlyDate;
